// @file Home Vuex Store.
import { fetchJson, HTTPMethod } from '@padlet/fetch'
import getCsrfToken from 'bits/csrf_token'
import { hyphenatedCurrentLocale } from 'bits/current_locale'
import { reload } from 'bits/location'
import { Plugin, StoreOptions } from 'vuex'
import browser from 'vuexstore/modules/browser'
import logger, { shouldLog } from 'vuexstore/plugins/logger'

const plugins: Array<Plugin<object>> = []
if (shouldLog) plugins.push(logger)

interface HomeStoreState {
  currentLocale: string
}

export const storeOptions: StoreOptions<HomeStoreState> = {
  plugins,
  modules: {
    browser,
  },
  state: {
    currentLocale: hyphenatedCurrentLocale,
  },
  actions: {
    async initializeState({ dispatch }): Promise<any> {
      return await dispatch('browser/initializeState')
    },
    async changeLocale({ commit }, e: Event): Promise<void> {
      const target = e.target as HTMLSelectElement
      const lang = target.value
      // Set locale in session
      await fetchJson('/session', {
        method: HTTPMethod.put,
        body: JSON.stringify({ lang }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCsrfToken(),
        },
      })
      reload()
    },
  },
}
